module.exports = __webpack_public_path__ + "img/red-title.814ea2f7.png";